import { DataVariants } from "../../../data/DataManager";

export const csv = {
  name: "csv",
  grid: {
    displayed: false,
    order: 19,
    sortable: false,
  },
  data: {
    variant: DataVariants.ENUM,
    options: [
      { label: "NA", value: "NA" },
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
  },
  display: {
    displayed: true,
  },
  form: {
    label: "CSV relevant?",
    displayed: false,
    disabled: true,
  },
};
